export default function buildLinkForButtons({
    custom,
    customUrl,
    postType,
    slug,
}) {
    if (custom) {
        return customUrl
    }

    if (postType && slug) {
        let url = `${postType}/`

        if (postType === 'page') {
            url = ''
        }

        if (postType === 'template') {
            url = 'template/'
        }

        return url + slug
    }
    return false
}
